import { createFileRoute } from '@tanstack/react-router';
import { CandidatesNewTemplate } from '@/features/agent/candidates/templates/CandidatesNewTemplate';

/** 候補者新規作成ページの検索パラメータ */
type CandidatesNewSearch = {
  /** 作成モード。'document' の場合は書類アップロードセクションを初期表示する */
  source?: 'document';
};

export const Route = createFileRoute('/agent/candidates/new/')({
  component: CandidatesNew,
  validateSearch: (search: Record<string, unknown>): CandidatesNewSearch => {
    return {
      source: search.source === 'document' ? 'document' : undefined,
    };
  },
});

function CandidatesNew() {
  const { source } = Route.useSearch();
  return <CandidatesNewTemplate showResumeUpload={source === 'document'} />;
}
